import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import Loadable from '@/components/Loadable'
import ServiceDetails from '@/modules/Users/pages/Patient/components/Attending/components/ServiceDetails'
import CallDetails from '@/modules/Users/pages/Patient/components/Attending/components/ServiceDetails/components/CallDetails'
import ProfessionalSearch from '../pages/ProfessionalSearch/ProfessionalSearch.page'

const ScheduleAppointment = Loadable(
  lazy(() => import('../pages/ScheduleAppointment/ScheduleAppointment.page')),
  true,
)

const ProfessionalAppointment = Loadable(
  lazy(
    () =>
      import('../pages/ProfessionalAppointment/ProfessionalAppointment.page'),
  ),
  true,
)

const AppointmentLogs = Loadable(
  lazy(() => import('../pages/AppointmentLogs/AppointmentLogs.page')),
  true,
)

const MedicalRecord = Loadable(
  lazy(() => import('../pages/MedicalRecord/MedicalRecord.page')),
  true,
)

const CommunicationLogs = Loadable(
  lazy(() => import('../pages/CommunicationLogs/CommunicationLogs.page')),
  true,
)

const AppointmentQueue = Loadable(
  lazy(() => import('../pages/AppointmentQueue/AppointmentQueue.page')),
  true,
)

const HistoryAppointment = Loadable(
  lazy(() => import('../pages/HistoryAppointment/HistoryAppointment.page')),
  true,
)

const MedicalReferral = Loadable(
  lazy(() => import('../pages/MedicalReferral/MedicalReferral.page')),
  true,
)

const MedicalReferralDetails = Loadable(
  lazy(
    () =>
      import(
        '../pages/MedicalReferral/components/MedicalReferralDetails/MedicalReferralDetails.component'
      ),
  ),
  true,
)
const PsyAliveNewSearch = Loadable(
  lazy(() => import('../pages/PsyAliveNewSearch/PsyAliveNewSearch.page')),
  true,
)

const Detective = Loadable(
  lazy(
    () =>
      import(
        '@/modules/Users/pages/Patient/components/Attending/components/Detective/Detective.component'
      ),
  ),
  true,
)

const SmartSearchAnalysis = Loadable(
  lazy(
    () =>
      import(
        '@/modules/Users/pages/Patient/components/Attending/components/SmartSearchAnalysis/SmartSearchAnalysis.component'
      ),
  ),
  true,
)

const ForwardingList = Loadable(
  lazy(() => import('../pages/ForwardingList/ForwardingList.page')),
  true,
)

const OutcomeChange = Loadable(
  lazy(() => import('../pages/OutcomeChange/OutcomeChange.page')),
  true,
)

const Recurrences = Loadable(
  lazy(() => import('../pages/Recurrences/Recurrences.page')),
  true,
)

const ProfessionalChange = Loadable(
  lazy(() => import('../pages/ProfessionalChange/ProfessionalChange.page')),
  true,
)

const TelemedicineRoutes: RouteObject = {
  path: 'atendimento',
  children: [
    {
      path: 'agendar/consulta',
      element: <ScheduleAppointment />,
    },
    {
      path: 'agendar/consulta/profissionais',
      element: <ProfessionalAppointment />,
    },
    {
      path: 'agendar/consulta/psicologos',
      element: <PsyAliveNewSearch />,
    },
    {
      path: 'agendar/consulta/especialidades',
      element: <ProfessionalSearch />,
    },
    { path: 'atendimento-log', element: <AppointmentLogs /> },
    {
      path: 'prontuario',
      element: <MedicalRecord />,
    },
    {
      path: 'logs-comunicacao',
      element: <CommunicationLogs />,
    },
    {
      path: 'fila-atendimento',
      element: <AppointmentQueue />,
    },
    { path: 'historico-atendimentos', element: <HistoryAppointment /> },
    {
      path: 'historico-atendimentos/detalhes-do-atendimento/:userId',
      element: <ServiceDetails />,
    },
    {
      path: 'historico-atendimentos/detalhes-atendimento/detalhes-consulta/:id',
      element: <CallDetails />,
    },
    {
      path: 'historico-atendimentos/detetive/:appointmentId',
      element: <Detective />,
    },
    { path: 'liberacao-plano-saude', element: <MedicalReferral /> },
    {
      path: 'liberacao-plano-saude/detalhes',
      element: <MedicalReferralDetails />,
    },
    {
      path: 'lista-de-encaminhamentos',
      element: <ForwardingList />,
    },
    {
      path: 'agenda-inteligente',
      element: <SmartSearchAnalysis />,
    },
    {
      path: 'alteracao-desfecho',
      element: <OutcomeChange />,
    },
    {
      path: 'recorrencias',
      element: <Recurrences />,
    },
    {
      path: 'troca-profissional',
      element: <ProfessionalChange />,
    },
  ],
}

export default TelemedicineRoutes
